export interface DynamicRange {
  title?: string
  name: string
  num?: number
  unit?: 'day' | 'week' | 'month' | 'quarter' | 'year'
  toDate?: boolean
  offset?: number
}

export interface DateRange {
  startDate: Date
  endDate: Date
}

export interface FixedDateRange extends DateRange {
  range?: string
  type?: 'fixed'
}
export interface DynamicDateRange {
  range?: string
  type?: 'dynamic'
  dynamic: DynamicRange
}

export type DateRangeValue = FixedDateRange | DynamicDateRange;

export enum Weekday {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}

export type DateRangeValueJson = { type: 'fixed', start_date: string, end_date: string } | { type: 'dynamic', dynamic: DynamicRange };

export type LegacyDateRangeValueJson = { type: 'dynamic' | 'fixed', value: string, name?: string };
